// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._8d0a21{margin-top:var(--small-spacer);text-align:right}._524b9a{text-align:center;transform:translateY(1em);color:var(--secondary);font-size:.75em;margin-top:3em}._524b9a svg:not([aria-current]){opacity:.5}._8d0a21+._524b9a{margin-top:-2.5em;transform:none}", ""]);
// Exports
exports.locals = {
	"footer": "_8d0a21",
	"bullets": "_524b9a"
};
module.exports = exports;
